// extracted by mini-css-extract-plugin
export default {"root":"AdminPage_root__0AXZ-","header":"AdminPage_header__CaKst","title":"AdminPage_title__YKRqz"};